module.exports = __webpack_public_path__ + "static/media/08_avatar_female.73f45a98.png";